
import { get, writable } from "svelte/store";


export const searchFilterStore = writable<boolean>();